import React from "react";

const NoResults = ({ message }) => (
  <div className="u-richtext">
    <p className="f-scale-body u-mt12 u-mb12 u-center">
      {message}
      <br />
      We still may be able to help. Call{" "}
      <span className="f-bold">
        <a href="tel:18663167263">1-866-316-7263</a>
      </span>
      .
    </p>
  </div>
);

export default NoResults;
